export default __webpack_public_path__ + "static/media/office1-after2-480w.77d167f6.webp";